var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54896 2.92664C7.84833 2.00537 9.15167 2.00538 9.45105 2.92664L10.184 5.1822C10.3179 5.59419 10.7018 5.87313 11.135 5.87315L13.5067 5.87324C14.4754 5.87328 14.8781 7.11283 14.0945 7.68223L12.1758 9.07634C11.8253 9.33098 11.6787 9.78231 11.8126 10.1943L12.5454 12.4499C12.8447 13.3712 11.7902 14.1373 11.0065 13.568L9.08775 12.174C8.73728 11.9194 8.26272 11.9194 7.91225 12.174L5.99347 13.568C5.20977 14.1373 4.15534 13.3712 4.45465 12.4499L5.18745 10.1943C5.3213 9.78231 5.17465 9.33098 4.8242 9.07634L2.90553 7.68223C2.12187 7.11283 2.52462 5.87328 3.49331 5.87324L5.86498 5.87315C6.29818 5.87313 6.6821 5.59419 6.81598 5.1822L7.54896 2.92664Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f18b2fadf3b42309674806de99238168.svg";
export { ForwardRef as ReactComponent };